import { IconName } from '../../../icon';
import { 
	EmptyComponentWrapper,
	StyledIcon
} from './emptyComponent.style';
import { LinkButton } from '../../../button/LinkButton';

interface EmptyComponentProps {
	text: string;
	showButton?: boolean;
	buttonText?: string;
	buttonLink?: string;
    buttonIcon?: IconName;
    mainIcon: IconName;
    target?: string;
}

export const EmptyComponent = ({ 
	text, 
	showButton, 
	buttonText, 
	buttonLink, 
	buttonIcon, 
	mainIcon,
	target
}: EmptyComponentProps) => {
	return (
		<EmptyComponentWrapper>
			<StyledIcon icon={mainIcon} />
			<p>{text}</p>
			{showButton && buttonText && buttonLink && (
				<LinkButton
					variant="secondary"
					label={buttonText}
					href={buttonLink}
					icon={buttonIcon}
					target={target}
				/>
			)}
		</EmptyComponentWrapper>
	);
};
